import { Modal, type ModalProps } from 'antd';
import { useEffect } from 'react';
import { adminModalStore } from 'store/adminModalStore';

type AdminModalProps = ModalProps;

export const AdminModal = ({ open, ...props }: AdminModalProps) => {
  useEffect(() => {
    adminModalStore.setOpen(Boolean(open));

    return () => {
      adminModalStore.setOpen(false);
    };
  }, [open]);

  return <Modal open={open} {...props} />;
};
